import * as types from './types'
// Profile
import { IProfileState } from '../../lib/interface'
import { IProfileAction } from './actions'

const defaultDataState = {
  factoids: [],
  classes: [],
  businessLines: [],
  locations: [],
  cachedTimestamp: ''
}

export const dataReducer = (state: any = defaultDataState, action: any) => {
  switch (action.type) {
    case types.LOAD_DATA_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false
      }
    case types.LOAD_DATA:
      return {
        ...state,
        loading: true
      }
    default:
      return state
  }
}

/**
 * Snackbar
 */

const defaultSnackbarState: any = {
  open: false,
  message: ''
}

export const snackbarReducer = (
  state: any = defaultSnackbarState,
  action: any
) => {
  switch (action.type) {
    case types.OPEN_SNACKBAR:
      return {
        open: true,
        message: action.payload
      }
    case types.CLOSE_SNACKBAR:
      return {
        open: false,
        message: ''
      }
    default:
      return state
  }
}

/**
 * Profile
 */


const agentBusinessUnit =
localStorage.getItem('agent-businessunit')

const businessUnitData = agentBusinessUnit ? JSON.parse(agentBusinessUnit) : false

const defaultProfileState: IProfileState = {
  name: '',
  given_name: '',
  email: '',
  authenticated: false,
  businessUnit: businessUnitData ? businessUnitData : {id: 0, name: ''}
}

export const profileReducer = (
  state: IProfileState = defaultProfileState,
  action: IProfileAction
) => {
  switch (action.type) {
    case types.AUTH_SUCCESS:
      return {
        ...state,
        ...action.payload,
        authenticated: true
      }
    case types.LOGOUT:
      return {
        name: '',
        given_name: '',
        email: '',
        authenticated: false
      }
    case types.SET_AGENT_BUSINESS_UNIT: 
    return {
      ...state,
      businessUnit: action.payload
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/core/duck/reducers.ts